/**
 * Internal constants.
 */
import { PropertyConvertingMode } from "./json-convert-enums.js";
export class Settings {
}
Settings.MAPPING_PROPERTY = "__jsonconvert__mapping__";
Settings.MAPPER_PROPERTY = "__jsonconvert__mapper__";
Settings.CLASS_IDENTIFIER = "__jsonconvert__class_identifier__";
;
/**
 * Internal mapping options for a property.
 */
export class MappingOptions {
    constructor() {
        this.classPropertyName = "";
        this.jsonPropertyName = "";
        this.expectedJsonType = undefined;
        this.convertingMode = PropertyConvertingMode.MAP_NULLABLE;
        this.customConverter = null;
    }
}
//# sourceMappingURL=json-convert-options.js.map